/**
 * Blog chrome: the blog hub page (src/routes/blog.index.tsx) and the shared
 * CMS article shell (src/routes/blog.$slug.tsx). Article bodies and the
 * hand-written blog.*.tsx article routes are NOT covered here — they stay
 * English by design.
 */

export const blogChrome = {
  en: {
    "blogc.eyebrow": "Clinical Library",
    "blogc.heading": "Evidence-based wellness guides.",
    "blogc.intro":
      "Long-form articles written and reviewed by the TruWe Science Team. No influencer takes, only published clinical evidence, clearly explained.",
    "blogc.exploreByTopic": "Explore by topic",
    "blogc.shopCta": "Shop {product} \u2192",
    "blogc.moreFromLibrary": "More from the library",
    "blogc.read": "Read",
    "blogc.clinicalLibraryLink": "Clinical Library",
    "blogc.keyTakeaways": "Key takeaways",
    "blogc.faqHeading": "Frequently asked questions",
    "blogc.referencesHeading": "References",
    "blogc.medicallyReviewedBy": "Medically reviewed by",
    "blogc.footerDisclaimer":
      "Educational content only, not medical advice. Consult a qualified healthcare professional before starting any supplement. Published at",
    "blogc.errorTitle": "This article couldn\u2019t be loaded.",
    "blogc.errorBody": "Please try again, or browse the",
    "blogc.notFoundTitle": "Article not found",
    "blogc.notFoundBody": "It may have been unpublished. Browse the",
  },
} as const;
